import useFetchAllNameSuffixes from './data-fetching/useAllNameSuffixes';
import useFetchApplicantFormData from './data-fetching/useApplicantFormData';
import useFetchAllStates from './data-fetching/useAllStates';
import useFetchAllCountries from './data-fetching/useAllCountries';
import useFetchAllEmploymentStatuses from './data-fetching/useAllEmploymentStatuses';
import useReferralTypes from '../../../hooks/data-fetching/useReferralTypes';
import useMinorAffordableRelationships from '../../../hooks/data-fetching/useMinorAffordableRelationships';
import useApplication from './data-fetching/useApplication';
import type { UseFormDataParams } from './types';

export default function useFormData({
  applicantId,
  applicationId,
  organizationId,
  propertyId,
}: UseFormDataParams) {
  const { nameSuffixes } = useFetchAllNameSuffixes();
  const { states } = useFetchAllStates();
  const { countries } = useFetchAllCountries();
  const { employmentStatuses, isLoading: employmentStatusesLoading } =
    useFetchAllEmploymentStatuses();
  const { referralTypes } = useReferralTypes();
  const { applicantFormData, isLoading: formDataLoading } =
    useFetchApplicantFormData({
      applicantId,
      organizationId,
      propertyId,
    });
  const {
    minorAffordableRelationships,
    isLoading: minorAffordableRelationshipsLoading,
  } = useMinorAffordableRelationships();
  const { application, isLoading: applicationLoading } = useApplication({
    applicationId,
    organizationId,
    propertyId,
  });

  // The relationships are waited for because they say which minors are
  // expected children, and those answers are filled in when the saved values
  // first load into the form.
  const isLoading =
    formDataLoading ||
    employmentStatusesLoading ||
    applicationLoading ||
    minorAffordableRelationshipsLoading;

  return {
    nameSuffixes,
    states,
    countries,
    employmentStatuses,
    referralTypes,
    applicantFormData,
    minorAffordableRelationships,
    application,
    isLoading,
  };
}
